import React from "react";
import "./salesRepClassificationCard.scss";

interface SaleRepClassificationCardProps {
  classList: string;
  cardImg: string;
  cardHeading: string;
  cardContent: any;
  subHeading: string;
  cardSelected: string;
  cardHandler: () => void;
  isDetailedView?: boolean;
  isEditMode?: boolean;
  editHandler?: () => void;
  isEditDisabled?: boolean;
}

const SaleRepClassificationCard = (props: SaleRepClassificationCardProps) => {
  const {
    classList,
    cardImg,
    cardHeading,
    subHeading,
    cardContent,
    cardSelected,
    cardHandler,
    isDetailedView = false,
    isEditMode = false,
    editHandler = () => { },
    isEditDisabled = false
  } = props;

  return (
    <div
      className={`cardBox 
        ${classList} ${cardSelected !== "" && cardSelected === cardHeading
          ? "isSelected"
          : null
        }
        ${cardSelected !== "" && cardSelected !== cardHeading
          ? "isNotSelected"
          : null
        }
        `}
      onClick={cardHandler}
      role="button"
    >
      {isEditMode ? <div>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" onClick={editHandler} height="16" fill={isEditDisabled ? "rgba(255,255,255,0.38)" : "#fff"} className="bi bi-pencil sales-rep-edit" viewBox="0 0 16 16">
          <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
        </svg>
      </div> : null}
      <div className="row padding-style">
        <div className="col-8 col-md-6  p-0">
          <p className="cardHeadingStyle">{cardHeading}</p>
          <p className="subHeading">{subHeading}</p>
          <div className="cardContent">
            <ul>
              {cardContent.map((data: string) => (
                <li key={data}>{data}</li>
              ))}
            </ul>
          </div>
        </div>
        <div className="col-4 col-md-6 p-0">
          <img src={cardImg} className="cardImgStyle" alt={cardHeading} />
        </div>
      </div>
      {isDetailedView && (
        <div className="row">
          <a
            href="/negotiation_strategy_types_details.pdf"
            target="_blank"
            style={{ textDecoration: "none" }}
          >
            <p className="cardReadMoreStyle">
              Read more <span className="readMoreIcon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.449 4.49905C10.6084 4.3397 10.8246 4.25018 11.05 4.25018C11.2753 4.25018 11.4915 4.3397 11.6509 4.49905L15.0509 7.89905C15.2103 8.05845 15.2998 8.27461 15.2998 8.5C15.2998 8.72539 15.2103 8.94155 15.0509 9.10095L11.6509 12.501C11.4906 12.6558 11.2759 12.7415 11.053 12.7395C10.8301 12.7376 10.617 12.6482 10.4594 12.4906C10.3018 12.333 10.2124 12.1198 10.2104 11.8969C10.2085 11.6741 10.2942 11.4594 10.449 11.2991L12.3981 9.35H2.54995C2.32452 9.35 2.10832 9.26045 1.94891 9.10104C1.7895 8.94164 1.69995 8.72544 1.69995 8.5C1.69995 8.27457 1.7895 8.05837 1.94891 7.89896C2.10832 7.73956 2.32452 7.65 2.54995 7.65H12.3981L10.449 5.70095C10.2897 5.54155 10.2001 5.32539 10.2001 5.1C10.2001 4.87461 10.2897 4.65845 10.449 4.49905Z"
                    fill="#FFF"
                  />
                </svg>
              </span>
            </p>
          </a>
        </div>
      )}
    </div>
  );
};

export default SaleRepClassificationCard;
